module.exports = __webpack_public_path__ + "static/media/search.717a491e.svg";